<div tabindex="-1" #splashScreenEl>
  <div siqGrid fx-direction="row" fx-layout-align="center center" class="splash-screen-container">
    <app-loading width="100px" height="100px"></app-loading>
  </div>
</div>